const SITE_ID = 1116
const API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaXRlX2lkIjoxMTE2LCJpYXQiOjE3NjE3NDUzMDksImp0aSI6ImcwdHdCSUc5TkhaQ1N0Ykl2WkJsTVRRVFlWMkpwaU05a3V0NVBwNlJjaVEifQ.m4Fg0_OnItwn0bAJjbRZrZRT91o25jOmbxKkn8HsGOw'

const formatPrice = (value) => Number(value ?? 0).toFixed(2)

const carouselsInit = async () => {
    const carousels = document.querySelectorAll('.js-recommendations-carousel')

    for (const carousel of carousels) {
        if (carousel.dataset.loaded === 'true') continue

        const slideshow = carousel.querySelector('.js-slideshow')
        const swiperContainer = carousel.querySelector('.js-swiper-container')

        const RECOMMENDATION_ID = carousel.id

        if (!RECOMMENDATION_ID || RECOMMENDATION_ID === '') continue

        let variablesObject = {}

        // Setting viewing product variable is on a PDP
        if (window.ShopifyAnalytics.meta.page.pageType === 'product') {
            variablesObject = {
                ...variablesObject,
                "viewing_item": String(window.ShopifyAnalytics.meta.product.id)
            }
        }

        // Setting cart items variable (adding IDs of items in cart to an array)
        const carReq = await fetch('/cart.js')
        const cart = await carReq.json()
        const cartProductIds = cart.items.map(item => String(item.product_id))

        if (cartProductIds.length) {
            variablesObject = {
                ...variablesObject,
                "cart_items": cartProductIds
            }
        }

        // Setting viewed items array as a variable (pulled from nyr.buildViewedItems() custom function)
        const viewedProducts = JSON.parse(localStorage.getItem('nyr_viewed_products') || '[]')

        variablesObject = {
            ...variablesObject,
            "viewed_items": viewedProducts
        }

        // Setting bought items as a variable (pulled from custom script to render array in theme.liquid)
        if (window.nyr_bought_items) {
            if (window.nyr_bought_items.length !== 0) {
                variablesObject = {
                    ...variablesObject,
                    "bought_items": window.nyr_bought_items
                }
            }
        }

        console.log(variablesObject)

        const query = JSON.stringify(variablesObject)

        const fields = JSON.stringify([
            'img_link',
            'id',
            'nyr_shopify_id',
            'price',
            'discount_rate',
            'stroke_price',
            'rating',
            'rating_count',
            'link',
            'name',
            'revenues_last_30_days'
        ])

        fetch(
            encodeURI(`https://uc-info.eu.abtasty.com/v1/reco/${SITE_ID}/recos/${RECOMMENDATION_ID}?variables=${query}&fields=${fields}`),
            {
                headers: {
                    Authorization: `Bearer ${API_KEY}`
                }
            }
        ).then(data => {
            return data.json()
        
        }).then(data => {            

            swiperContainer.innerHTML = data.items.map(item => {
                const hasDiscount = item.discount_rate != null && item.stroke_price != 0.00 && item.stroke_price != null
                const salePriceHtml = hasDiscount ? `
                                        <div class="price__sale visible">
                                            <div class="price__sale__details-wrapper">
                                                <span class="price-item price-item--sale price-item--last wt-product__price__final">£${formatPrice(item.price)}</span>
                                                <span class="price-item--percent"> -${item.discount_rate}% </span>
                                            </div>
                                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                            <div class="price__details">
                                              <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            </div>
                                            <span>
                                            <s class="price-item price-item--regular price-item--lower wt-product__price__compare ">£${formatPrice(item.stroke_price)}</s>
                                            </span>
                                        </div>
                ` : ''

                const priceClass = hasDiscount ? 'price price--on-sale' : 'price'

                let ratingValue = 0
                try {
                    const ratingObj = typeof item.rating === 'string' ? JSON.parse(item.rating) : item.rating
                    ratingValue = Number(ratingObj && ratingObj.value) || 0
                } catch (e) {
                    ratingValue = 0
                }

                const rating = ratingValue
                const roundedRating = Math.round(rating * 2) / 2
                const fullStars = Math.floor(roundedRating)
                const hasHalfStar = roundedRating - fullStars === 0.5
                const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0)

                const starsHtml =
                    `${'<span class="jdgm-star jdgm--on"></span>'.repeat(fullStars)}` +
                    `${hasHalfStar ? '<span class="jdgm-star jdgm--half"></span>' : ''}` +
                    `${'<span class="jdgm-star jdgm--off"></span>'.repeat(emptyStars)}`

                return `
                <div data-swiper-slide class="wt-slider__card-wrapper" data-item-id="${item.nyr_shopify_id}">
                    <color-swatch>
                      <div class="card__container" style="--aspect-ratio: 1;">
                        <div class="card__picture-container">
                            <a href="${item.link}" class="card card--center" tabindex="0" aria-label="Open product page" data-reco-click="go_to_page">
                                <picture class="card__picture">
                                    <img class="card__img" alt="${item.name}" src="${item.img_link}&width=500" loading="lazy"
                                        srcset="
                                            ${item.img_link}&width=400 400w,
                                            ${item.img_link}&width=600 600w,
                                            ${item.img_link}&width=800 800w,
                                            ${item.img_link}&width=1000 1000w
                                        "
                                        sizes="(max-width: 899px) 50vw, (min-width: 900px) 25vw, 500">
                                    <img class="card__img card__img--hover" alt="${item.name}" src="${item.img_link}&width=500" loading="lazy"
                                        srcset="
                                            ${item.img_link}&width=400 400w,
                                            ${item.img_link}&width=600 600w,
                                            ${item.img_link}&width=800 800w,
                                            ${item.img_link}&width=1000 1000w,
                                        "
                                        sizes="(max-width: 899px) 50vw, (min-width: 900px) 25vw, 500">
                                </picture>
                            </a>
                            <div class="card__quick-add-container--desktop">
                                <product-form class="wt-product__add-to-cart" data-hide-errors="">
                                    <div class="product-form__error-message-wrapper" role="alert" hidden="">
                                        <span class="product-form__error-message"></span>
                                    </div>
                                    <form method="post" action="/cart/add" accept-charset="UTF-8" class="wt-product__add-to-cart_form form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                        <input type="hidden" name="form_type" value="product" tabindex="0">
                                        <input type="hidden" name="utf8" value="✓" tabindex="0">
                                        <div class="wt-product__add-to-cart_form--wrapper">
                                            <input type="hidden" name="id" value="${item.nyr_shopify_id}" tabindex="0">
                                            <button aria-label="Add to bag" id="ProductSubmitButton-template--20532097548508__featured_collection_Lb6AfR" type="submit" name="add" class="wt-button--full-width hero__button hero__button--primary" aria-haspopup="dialog" tabindex="0" data-reco-click="add_to_cart_item">
                                                <span>Add to bag</span>
                                                <div class="loading-overlay__spinner hidden">
                                                  <div class="lds-ring" aria-hidden="true">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                  </div>
                                                </div>
                                            </button>
                                        </div>
                                        <input type="hidden" name="product-id" value="${item.nyr_shopify_id}" tabindex="0">
                                        <input type="hidden" name="section-id" value="template--20532097548508__featured_collection_Lb6AfR" tabindex="0">
                                    </form>
                                </product-form>
                            </div>
                        </div>
                        <a href="${item.link}" tabindex="-1" data-omit-tabindex="" class="card card--center" data-reco-click="go_to_page">
                            <h3 class="card__title">${item.name}</h3>
                            <div class="card__price">
                                <div class="${priceClass}">
                                    <div class="price__container">
                                        <div class="price__regular">
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            <span class="price-item price-item--regular wt-product__price__final wt-product__price__final">£${formatPrice(item.price)}</span>
                                        </div>
                                        ${salePriceHtml}
                                        <small class="unit-price caption hidden">
                                          <span class="visually-hidden">Unit price</span>
                                          <span class="price-item price-item--last">
                                            <span></span>
                                            <span aria-hidden="true">/</span>
                                            <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                            <span>
                                            </span>
                                          </span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-widget-name="preview_badge" data-impressions-tracked="true" data-views-tracked="true">
                                <div style="display:none" class="jdgm-prev-badge" data-average-rating="${ratingValue}" data-number-of-reviews="${item.rating_count}" data-number-of-questions="0">
                                    <span class="jdgm-prev-badge__stars" data-score="${ratingValue}" tabindex="0" aria-label="${item.rating} stars" role="button">
                                    ${starsHtml}
                                    </span> <span class="jdgm-prev-badge__text">(${item.rating_count})</span>
                                </div>
                            </div>
                        </a>
                        <div class="card__quick-add-container">
                            <product-form class="wt-product__add-to-cart" data-hide-errors="">
                                <div class="product-form__error-message-wrapper" role="alert" hidden="">
                                  <span class="product-form__error-message"></span>
                                </div>
                                <form method="post" action="/cart/add" accept-charset="UTF-8" class="wt-product__add-to-cart_form form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                    <input type="hidden" name="form_type" value="product" tabindex="0">
                                    <input type="hidden" name="utf8" value="✓" tabindex="0">
                                  <div class="wt-product__add-to-cart_form--wrapper">
                                    <input type="hidden" name="id" value="${item.nyr_shopify_id}" tabindex="0">
                                    <button aria-label="Add to bag" id="ProductSubmitButton-template--20532097548508__featured_collection_Lb6AfR" type="submit" name="add" class="wt-button--full-width hero__button hero__button--primary" aria-haspopup="dialog" tabindex="0" data-reco-click="add_to_cart_item">
                                        <span>Add to bag</span>
                                        <div class="loading-overlay__spinner hidden">
                                          <div class="lds-ring" aria-hidden="true">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                          </div>
                                        </div>
                                    </button>
                                  </div>
                                  <input type="hidden" name="product-id" value="${item.nyr_shopify_id}" tabindex="0">
                                  <input type="hidden" name="section-id" value="template--20532097548508__featured_collection_Lb6AfR" tabindex="0">
                                </form>
                            </product-form>
                        </div>
                        </div>
                    </color-swatch>
                </div>
            `}).join('')
        }).finally(() => {
            // 2.3.0: swiperInitilize() now guards against re-init (if (this.swiper) return).
            // Destroy the empty swiper that connectedCallback created before AB Tasty loaded,
            // then re-init so the fetched slides get swiper-slide classes and Swiper picks them up.
            if (slideshow.swiper) slideshow.swiperDestroy()
            slideshow.swiperInitilize()
            carousel.setAttribute('data-reco-id', RECOMMENDATION_ID)
        }).catch(error => {
            console.log(error, 'Failed to fetch recommendations')
        })
    }
}
carouselsInit().then(() => {})